var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1127","data-name":"Group 1127","transform":"translate(-428.001 -956.869)"},React.createElement("path",{"id":"Union_4","data-name":"Union 4","d":"M8960-7398.13a3,3,0,0,1-3-3v-12a3,3,0,0,1,3-3h5a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2h5a3,3,0,0,1,3,3v12a3,3,0,0,1-3,3Zm4-9a6.007,6.007,0,0,0,6,6,6.007,6.007,0,0,0,6-6,6.006,6.006,0,0,0-6-6A6.007,6.007,0,0,0,8964-7407.132Zm12-5a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0,8976-7412.13Zm-10,5a4,4,0,0,1,4-4,4,4,0,0,1,4,4,4,4,0,0,1-4,4A4,4,0,0,1,8966-7407.13Z","transform":"translate(-8529 8375)","fill":"#fff"})));
}

Camera.defaultProps = {"width":"26","height":"20.001","viewBox":"0 0 26 20.001"};

module.exports = Camera;

Camera.default = Camera;
